module.exports = __webpack_public_path__ + "static/img/student-bg.affbe5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/student-bg.png
// module id = BRER
// module chunks = 1